import { AvatarData } from "../types/avatar";
import { getNewestPlaces } from "../services/placeService";
import { useState, useEffect } from "react";

export const useLastPlaces = (t: (key: string) => string): AvatarData[] => {
  const [avatars, setAvatars] = useState<AvatarData[]>([]);

  useEffect(() => {
    let isMounted = true;
    getNewestPlaces(t).then((data) => {
      if (isMounted) setAvatars(data);
    });
    return () => {
      isMounted = false;
    };
  }, [t]);

  return avatars;
};
